import { render, staticRenderFns } from "./FooterMenuLink.vue?vue&type=template&id=022927ff&scoped=true&"
import script from "./FooterMenuLink.vue?vue&type=script&lang=js&"
export * from "./FooterMenuLink.vue?vue&type=script&lang=js&"
import style0 from "./FooterMenuLink.vue?vue&type=style&index=0&id=022927ff&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022927ff",
  null
  
)

export default component.exports